// apps/web/src/lib/session.ts — Fase 06, Plano 04 (D-02, D-05, D-08).
// Consulta da sessão autenticada atual via GET /api/v1/auth/me.
import type { SessaoAtualResponse } from '@pieltec/contracts';

export type ObterSessaoResult =
  | { readonly autenticado: true; readonly usuario: SessaoAtualResponse }
  | { readonly autenticado: false };

/**
 * Consulta a identidade e permissões da sessão atual.
 * Não lança erro em 401 ou falha de rede: devolve resultado discriminado.
 */
export async function obterSessaoAtual(
  fetchImpl: typeof fetch = typeof window !== 'undefined' ? window.fetch.bind(window) : fetch,
): Promise<ObterSessaoResult> {
  try {
    const res = await fetchImpl('/api/v1/auth/me', {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    });

    if (res.status === 200) {
      const data = (await res.json()) as SessaoAtualResponse;
      return {
        autenticado: true,
        usuario: data,
      };
    }

    return { autenticado: false };
  } catch {
    return { autenticado: false };
  }
}
